import Auth from './auth'
import { JwtCookie } from '../services/jwtCookie.service.js'

export const authGuard = (to, from, next) => {
  const authService = Auth.getInstance()
  const onboardingStep = JwtCookie.getJwtCookie('fooshistep')
  if (authService.isAuthenticated) {
    if (onboardingStep === 'vendor-setup' && to.path !== '/account-details') {
      return next({ path: '/account-details' })
    } else if (onboardingStep === 'account-details' && to.path !== '/account-details-owner') {
      return next({ path: '/account-details-owner' })
    } else if (onboardingStep === 'conditions' && to.path !== '/terms-and-conditions') {
      return next({ path: '/terms-and-conditions' })
    } else {
      return next()
    }
  } else {
    return next({ path: '/login' })
  }
}



// WEBPACK FOOTER //
// ./src/auth/authGuard.js